var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"light":""}},[_c('div',{staticClass:"layout"},[_c('router-view',{class:['layout__main', _vm.searchViewClass]}),_c('TheNavbar',{staticClass:"layout__navbar"})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }